import {
  Alert,
  AlertProps,
  Badge,
  BadgeProps,
  ButtonProps,
  ContextMenu,
  InputGroup,
  SkeletonLoader,
  TDropdownItem,
} from '@payaca/ambrosia';
import { FC, PropsWithChildren } from 'react';

export interface IProps {
  title?: string;
  badge?: PropsWithChildren<BadgeProps>;
  firstAction?: PropsWithChildren<ButtonProps>;
  actions?: TDropdownItem[];
  alerts?: PropsWithChildren<AlertProps>[];
}

const PreviewDocument: FC<PropsWithChildren<IProps>> = (props) => {
  const {
    title,
    badge,
    firstAction,
    actions = [],
    alerts = [],
    children,
  } = props;

  return (
    <div className="flex">
      <div className="typography:prose mx-auto w-full max-w-[1200px]">
        {/*Alerts*/}
        {!!alerts.length && (
          <div className="mb-4">
            {alerts.map((alert, index) => (
              <Alert key={index} {...alert} />
            ))}
          </div>
        )}

        {/*Header*/}
        <div className="mb-4 flex items-center justify-between gap-4">
          <h1>{title}</h1>

          {badge && <Badge {...badge} />}

          <div className="ml-auto">
            <InputGroup className="bg-white" sizeVariant="md">
              {firstAction && (
                <InputGroup.Button variant={'outline'} {...firstAction} />
              )}

              {actions.length > 0 && (
                <ContextMenu
                  as={InputGroup.Button}
                  variant={'outline'}
                  menuItems={actions}
                />
              )}
            </InputGroup>
          </div>
        </div>

        {/*Main Context*/}
        {children}
      </div>
    </div>
  );
};

export const PreviewDocumentSkeleton: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className="flex">
      <div className="typography:prose mx-auto w-full max-w-[1200px]">
        {/*Header*/}
        <div className="mb-4 flex items-center justify-between gap-4">
          <SkeletonLoader.Title className="h-8 w-1/4" />
          <SkeletonLoader.Badge />
          <SkeletonLoader.Button className="w-20 ml-auto" />
        </div>

        {/*Main Context*/}
        {children}
      </div>
    </div>
  );
};

export default PreviewDocument;
